import { usePromoteFormState } from '../../../../formContext';

export function useValidationError(): { error: string | undefined } {
	const [{ validationErrors }] = usePromoteFormState();

	return { error: validationErrors?.amountSelection };
}
